/** Obstacles with this tag are guide signs whose arrows must point to a free lane. */
export const GUIDE_TAG = 'guide';

/** ENV_ChevronSign_A reads "<<<<" from its front (+z) and ">>>>" from behind. */
export const GUIDE_POINTS_RIGHT = 0; // the runner sees the back: ">>>>"
export const GUIDE_POINTS_LEFT = Math.PI; // turned around, the runner sees the front: "<<<<"

/**
 * Visual yaw for a guide sign that closes `lane` (index 0 = left lane): the arrows point to the
 * nearest lane of the same row without an obstacle; on a tie to the right ("rechts vorbei").
 * With no free lane left in the row the sign points towards the track center.
 */
export function guideYaw(lane: number, laneCount: number, occupied: ReadonlySet<number>): number {
  for (let step = 1; step < laneCount; step++) {
    if (lane + step < laneCount && !occupied.has(lane + step)) return GUIDE_POINTS_RIGHT;
    if (lane - step >= 0 && !occupied.has(lane - step)) return GUIDE_POINTS_LEFT;
  }
  return lane < (laneCount - 1) / 2 ? GUIDE_POINTS_RIGHT : GUIDE_POINTS_LEFT;
}
